export default {
  specificationList: [
    {
      value: 'IPC 600G Class II',
      label: 'IPC 600G Class II'
    }
  ],
  measurementUnitList: [
    {
      value: 'mm',
      label: 'mm'
    }
    // {
    //   value: 'inches',
    //   label: 'inches'
    // },
    // {
    //   value: 'cm',
    //   label: 'cm'
    // }
  ],
  dateCodeList: [
    {
      value: 'week/year',
      label: 'week/year'
    },
    {
      value: 'week:year',
      label: 'week:year'
    },
    {
      value: 'year/week',
      label: 'year/week'
    },
    {
      value: 'year:week',
      label: 'year:week'
    },
    {
      value: 'weekyear',
      label: 'weekyear'
    },
    {
      value: 'yearweek',
      label: 'yearweek'
    }
  ],
  copperWeightList: [
    {
      value: '18µm(0.5 oz)',
      label: '18µm(0.5 oz)'
    },
    {
      value: '35µm(1 oz)',
      label: '35µm(1 oz)'
    },
    {
      value: '70µm(2 oz)',
      label: '70µm(2 oz)'
    }
  ],
  surfaceFinishList: [
    {
      value: 'Immersion Gold',
      label: 'Immersion Gold'
    },
    {
      value: 'Immersion Tin',
      label: 'Immersion Tin'
    }
  ],
  materialList: [
    {
      value: 'FR-4(TG 130)',
      label: 'FR-4(TG 130)'
    },
    {
      value: 'FR-4(TG 170)',
      label: 'FR-4(TG 170)'
    }
  ],
  solderMaskList: [
    {
      value: 'Green',
      label: 'Green'
    },
    {
      value: 'Red',
      label: 'Red'
    },
    {
      value: 'Blue',
      label: 'Blue'
    },
    {
      value: 'Black',
      label: 'Black'
    },
    {
      value: 'White',
      label: 'White'
    },
    {
      value: 'Matte',
      label: 'Matte'
    }
  ],
  legendColorList: [
    {
      value: 'White',
      label: 'White'
    },
    {
      value: 'Yellow',
      label: 'Yellow'
    },
    {
      value: 'Black',
      label: 'Black'
    }
  ],
  numberLayers: [
    {
      value: 2,
      label: '2'
    },
    {
      value: 4,
      label: '4'
    },
    {
      value: 6,
      label: '6'
    },
    {
      value: 8,
      label: '8'
    }
  ]
}
